import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { TESTIDS } from "@/constants/testIds";
import { FAQS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid={TESTIDS.faq.section} className="py-24 lg:py-32 px-5 sm:px-8">
    <div className="mx-auto max-w-3xl">
      <Reveal>
        <p className="text-sm tracking-widest uppercase text-violet-deep font-600 text-center">FAQ</p>
        <h2 className="mt-4 font-display font-700 text-4xl sm:text-5xl tracking-tighter text-ink text-center">
          Najczęstsze pytania
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={TESTIDS.faq.item(i)}
              className="rounded-2xl bg-white border border-ink/5 px-6"
            >
              <AccordionTrigger className="font-display font-600 text-lg text-ink hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ink/60 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
